import { parseBoolean } from '@/utils/parse.js'

export const JITSI_BALANCE_CHECK_INTERVAL = 1000
export const JITSI_TIPS_CHECK_INTERVAL = 10000
export const JITSI_PAYMENT_CHECK_INTERVAL = 5000

export const JITSI_REGIONS_ENABLED = parseBoolean(import.meta.env.VITE_JITSI_REGIONS_ENABLED)

export const getJitsiDomain = region => {
  if (!JITSI_REGIONS_ENABLED) return import.meta.env.VITE_JITSI_FRONTEND_DOMAIN

  if (region === 'northamerica' || region === 'southamerica')
    return `us.${import.meta.env.VITE_JITSI_FRONTEND_DOMAIN}`

  if (region === 'oceania' || region === 'asia')
    return `as.${import.meta.env.VITE_JITSI_FRONTEND_DOMAIN}`

  if (region === 'middleeast') return `me.${import.meta.env.VITE_JITSI_FRONTEND_DOMAIN}`

  return `eu.${import.meta.env.VITE_JITSI_FRONTEND_DOMAIN}`
}

// https://github.com/jitsi/jitsi-meet/blob/master/config.js
export const getJitsiConfig = (region, isLivestream, isLivestreamGuest) => {
  const config = {
    deploymentInfo: {
      userRegion: region,
    },
    doNotFlipLocalVideo: true,
    resolution: 1080,
    startWithAudioMuted: true,
    startWithVideoMuted: true,
  }

  if (isLivestream) config.disablePolls = true

  if (isLivestreamGuest)
    return {
      ...config,
      disableSelfView: true,
      disableSelfViewSettings: true,
      filmstrip: {
        disableStageFilmstrip: true,
        disableTopPanel: true,
        disabled: true,
      },
      tileView: {
        disabled: true,
      },
      toolbarButtons: [
        'recording',
        'videoquality',
        'chat',
        'fullscreen',
        'help',
        'feedback',
        'hangup',
        'invite',
        'highlight',
        'closedcaptions',
      ],
    }

  return {
    ...config,
    participantMenuButtonsWithNotifyClick: [
      'mute',
      'mute-video',
      'allow-video',
      {
        key: 'ask-unmute',
        preventExecution: false,
      },
    ],
  }
}

// https://github.com/jitsi/jitsi-meet/blob/master/interface_config.js
export const getJitsiInterfaceConfig = isLivestream =>
  isLivestream
    ? {
        DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
        VERTICAL_FILMSTRIP: false,
      }
    : {}
